import Login from "../../screens/auth/Login";
import DesignationCE from "../../screens/options/designation/DesignationCE";
import DepartmentCE from "../../screens/options/department/DepartmentCE";
import DepartmentList from "../../screens/options/department/DepartmentList";
import DesignationList from "../../screens/options/designation/DesignationList";
import RoleList from "../../screens/options/roles/RoleList";
import RoleCE from "../../screens/options/roles/RoleCE";
import Settings from "../../screens/staticscreens/Settings";
import Profile from "../../screens/profile/Profile";


import Mainprofile from "../../screens/profile/Mainprofile";
import UpdatePassword from "../../screens/auth/UpdatePassword";
import Account from "../../screens/profile/Account";

import OnboardList from "../../screens/onboard/OnboardList";
import Onboard from "../../screens/onboard/Onboard";
import DashboardMenu from "../../screens/dashboard/DashboardMenu";
import Dashboard from "../../screens/dashboard/Dashboard";


import SubscriptionPoint from "../../screens/developer/SubscriptionPoint";
import DistributorSubscriptionPoint from "../../screens/developer/DistributorSubscriptionPoint";
import FollowUpList from "../../screens/developer/followup/FollowUpList";
import FollowUpCE from "../../screens/developer/followup/FollowUpCE";
import ClientMenu from "../../screens/vehicle/ClientMenu";
import ClientList from "../../screens/vehicle/ClientList";
import ClientListCE from "../../screens/vehicle/ClientListCE";
import LeaderBoard from "../../screens/dashboard/LeaderBoard";
import AdminClients from "../../screens/dashboard/AdminClients";
import WatiList from "../../screens/options/wati/WatiList";
import WatiCE from "../../screens/options/wati/WatiCE";
import AdminClientsVisibalityDisabled from "../../screens/dashboard/AdminClientsVisibalityDisabled";
import LeaderBoardTransaction from "../../screens/dashboard/LeaderBoardTransaction";
import Notification from "../../screens/Notification";
import ClientCall from "../../screens/vehicle/ClientCall";
import ClientCallCE from "../../screens/vehicle/ClientCallCE";
import ClientAssignTime from "../../screens/developer/ClientAssignTime";
import WatiTemplateList from "../../screens/options/wati/WatiTemplateList";
import WatiTemplateDetail from "../../screens/options/wati/WatiTemplateDetail";
import WorkFromHomeEmployeeOption from "../../screens/developer/WorkFromHomeEmployeeOption";
import WithDrawMenu from "../../screens/withdraw/WithDrawMenu";
import WithDrawRequestList from "../../screens/withdraw/WithDrawRequestList";
import WithDrawCE from "../../screens/withdraw/WithDrawCE";
import AdminWithDrawRequestList from "../../screens/dashboard/AdminWithDrawRequestList";
import AdminSubscribedClientsTransfer from "../../screens/dashboard/AdminSubscribedClientsTransfer";
import ClientExcelUpload from "../../screens/developer/ClientExcelUpload";
import MetaList from "../../screens/options/wati/MetaList";
import CallFollowUpList from "../../screens/vehicle/CallFollowUpList";
import ClientCallFollowUpCE from "../../screens/vehicle/ClientCallFollowUpCE";
import AdminCallFollowUpList from "../../screens/dashboard/AdminCallFollowupList";
import AdminClientsAnalytics from "../../screens/dashboard/AdminClientsAnalytics";
import FileStandardList from "../../screens/developer/filestandard/FileStandardList";
import FileStandardCE from "../../screens/developer/filestandard/FileStandardCE";
import ReTargetCustomerList from "../../screens/developer/retarget_customer/ReTargetCustomerList";
import ReTargetCustomerCE from "../../screens/developer/retarget_customer/ReTargetCustomerCE";
import ReTargetClients from "../../screens/dashboard/ReTargetClients";
import AdminChatWindow from "../../screens/dashboard/AdminChatWindow";
import TrackEmployeeClients from "../../screens/dashboard/TrackEmployeeClients";
import TrackEmployeeClientsDetail from "../../screens/dashboard/TrackEmployeeClientsDetail";
import VoiceCallList from "../../screens/developer/voicecall/VoiceCallList";
import VoiceCallListDetail from "../../screens/developer/voicecall/VoiceCallListDetail";
import VoiceCallListAssignedAnswered from "../../services/VoiceCallListAssignedAnswered";
import GetCustomerChatList from "../../screens/options/wati/GetCustomerChatList";
import LeaderBoardWorkStatus from "../../screens/dashboard/LeaderBoardWorkStatus";
import TemplateList from "../../screens/options/wati/TemplateList";
import TemplateCE from "../../screens/options/wati/TemplateCE";
import TemplateTargetList from "../../screens/developer/massTemplateMessage/TemplateTagetList";
import TemplateTargetListDetail from "../../screens/developer/massTemplateMessage/TemplateTargetListDetail";
import MassMessageListDeliveredAnswered from "../../services/MassMessageListDeliveredAnswered";
import WebsiteMessageList from "../../screens/options/wati/WebsiteMessageList";
import TemplateListWelcome from "../../screens/options/wati/TemplateListWelcome";
import LiveClassList from "../../screens/liveclass/live_class_list";
import LiveClassListAttendees from "../../screens/liveclass/live_class_list_attendees";
import LiveClassListCE from "../../screens/liveclass/live_class_list_ce";
import TeacherList from "../../screens/class_booking/TeacherList";
import TeacherCE from "../../screens/class_booking/TeacherCE";
import ClassBookingCount from "../../screens/class_booking/ClassBookingCount";
import PersonalTrainingSubscriptionList from "../../screens/class_booking/PersonalTrainingSubscriptionList";
import PersonalTrainingSubscriptionCE from "../../screens/class_booking/PersonalTrainingSubscriptionCE";
import BookingSlot from "../../screens/class_booking/BookingSlot";
import BookingSlotCE from "../../screens/class_booking/BookingSlotCE";
import TeacherClassBookingList from "../../screens/teacher_class_booking/TeacherClassBookingList";
import TeacherClassBookingCE from "../../screens/teacher_class_booking/TeacherClassBookingCE";
import TeacherClassBookingMenu from "../../screens/teacher_class_booking/TeacherClassBookingMenu";
import MyTimeTableList from "../../screens/teacher_class_booking/MyTimeTableList";
import TodayTimeTableList from "../../screens/teacher_class_booking/TodayTimeTableList";
import BatchesSlot from "../../screens/class_booking/BatchesSlot";
import BatchesSlotCE from "../../screens/class_booking/BatchesSlotCE";
import BatchBookingMenu from "../../screens/batch_booking/BatchBookingMenu";
import BatchBookingList from "../../screens/batch_booking/BatchBookingList";
import BatchBookingCE from "../../screens/batch_booking/BatchBookingCE";
import BatchCustomDownload from "../../screens/batch_booking/BatchCustomDownload";
import ClassHomePageDataList from "../../screens/class_booking/ClassHomePageDataList";
import ClassHomePageDataCE from "../../screens/class_booking/ClassHomePageDataCE";
import DemoBookingList from "../../screens/class_booking/DemoBookingList";
import DemoBookingCE from "../../screens/class_booking/DemoBookingCE";
import BatchSubscriptionList from "../../screens/class_booking/BatchSubscriptionList";
import BatchSubscriptionCE from "../../screens/class_booking/BatchSubscriptionCE";
import GetSubscriptionRequestList from "../../screens/class_booking/GetSubscriptionRequestList";
import BatchSubscriptionTimeTable from "../../screens/class_booking/BatchSubscriptionTimeTable";
import BatchSubscriptionTimeTableCE from "../../screens/class_booking/BatchSubscriptionTimeTableCE";
import BatchSubscriptionTimeTableStudentSummary from "../../screens/class_booking/BatchSubscriptionTimeTableStudentSummary";
import StudentSubjectList from "../../screens/developer/studentSubject/StudentSubjectList";
import StudentSubjectCE from "../../screens/developer/studentSubject/StudentSubjectCE";
import StudentStreamCE from "../../screens/developer/studentStream/StudentStreamCE";
import StudentStreamList from "../../screens/developer/studentStream/StudentStreamList";
import StudentBoardCE from "../../screens/developer/studentBoard/StudentBoardCE";
import StudentBoardList from "../../screens/developer/studentBoard/StudentBoardList";
import SubjectList from "../../screens/developer/SubjectList";
import SubjectCE from "../../screens/developer/SubjectCE";
import ChapterList from "../../screens/developer/ChapterList";
import ChapterCE from "../../screens/developer/ChapterCE";
import CounsellingFollowupList from "../../screens/counselling_followup/CounsellingFollowupList";
import CounsellingFollowupMenu from "../../screens/counselling_followup/CounsellingFollowupMenu";
import ClientExcelUploadToTeacher from "../../screens/developer/ClientExcelUploadToTeacher";
import TeacherLogin from "../../screens/auth/TeacherLogin";
import DigitalCardList from "../../screens/developer/digitalcard/DigitalCardList";
import DigitalCardCE from "../../screens/developer/digitalcard/DigitalCardCE";
import DigitalCardDistributorList from "../../screens/developer/digitalcarddistributor/DigitalCardDistributorList";
import DigitalCardDistributorCE from "../../screens/developer/digitalcarddistributor/DigitalCardDistributorCE";

import FranchiseRequestList from "../../screens/developer/franchise_request/FranchiseRequestList";
import FranchiseRequestCE from "../../screens/developer/franchise_request/FranchiseRequestCE";

import ClassRoomList from "../../screens/developer/classRoom/ClassRoomList";
import ClassRoomCE from "../../screens/developer/classRoom/ClassRoomCE";

import OfflineCustomerList from "../../screens/offline_customer/OfflineCustomerList";
import OfflineCustomerCE from "../../screens/offline_customer/OfflineCustomerCE";
import InvoiceMenu from "../../screens/invoice/InvoiceMenu";
import InvoiceList from "../../screens/invoice/InvoiceList";
import InvoiceCE from "../../screens/invoice/InvoiceCE";
import PublicFeedbackMobileEntry from "../../screens/teacher_feedback/PublicFeedbackMobileEntry";
import PublicFeedbackTeacherList from "../../screens/teacher_feedback/PublicFeedbackTeacherList";
import PublicFeedbackForm from "../../screens/teacher_feedback/PublicFeedbackForm";
import TeacherFeedbackLeaderboard from "../../screens/teacher_feedback/TeacherFeedbackLeaderboard";
import AdminTeacherFeedbackList from "../../screens/teacher_feedback/AdminTeacherFeedbackList";

import CurrentLinkModel from '../../screens/developer/CurrentLinkModel'
import CityList from "../../screens/developer/CityList";

export const routes = [
    {
        path:"/",
        component:<Login/>,
        private:false,
        roles:[]
    },
     {
        path:"/teacher_login",
        component:<TeacherLogin/>,
        private:false,
        roles:[]
    },
    {
        path:"/settings",
        component:<Settings/>,
        private:true,
        roles:['controller','admin']
    },

    {
        path:"/settings/followup_list",
        component:<FollowUpCE/>,
        private:true,
        roles:['app_developer']
    },
     {
        path:"/settings/followup_list/:type",
        component:<FollowUpCE/>,
        private:true,
        roles:['app_developer']
    },

    {
        path:"/settings/filter_standard",
        component:<FileStandardList/>,
        private:true,
        roles:['app_developer']
    },
    {
        path:"/digital_card",
        component:<DigitalCardList />,
        private:true,
        roles:['app_developer','Distributor']
    },
    {
        path:"/digital_card/:type",
        component:<DigitalCardList />,
        private:true,
        roles:['app_developer','Distributor']
    },
    {
        path:"/digital_card/:type/:type",
        component:<DigitalCardCE />,
        private:true,
        roles:['app_developer']
    },
    {
        path:"/settings/digital_card/:type",
        component:<DigitalCardList />,
        private:true,
        roles:['app_developer','Distributor']
    },
    {
        path:"/settings/digital_card/:type/:type",
        component:<DigitalCardCE />,
        private:true,
        roles:['app_developer']
    },
    {
        path:"/settings/franchise_request",
        component:<FranchiseRequestList />,
        private:true,
        roles:['app_developer','Distributor']
    },
    {
        path:"/settings/franchise_request/",
        component:<FranchiseRequestList />,
        private:true,
        roles:['app_developer','Distributor']
    },
    {
        path:"/settings/franchise_request/:type",
        component:<FranchiseRequestCE />,
        private:true,
        roles:['app_developer']
    },
    {
        path:"/settings/digital_card",
        component:<DigitalCardList />,
        private:true,
        roles:['app_developer']
    },
    {
        path:"/settings/digital_card/:type",
        component:<DigitalCardCE/>,
        private:true,
        roles:['app_developer']
    },
     {
        path:"/settings/filter_standard/:type",
        component:<FileStandardCE/>,
        private:true,
        roles:['app_developer']
    },

    {
        path:"/settings/retarget_customer",
        component:<ReTargetCustomerList/>,
        private:true,
        roles:['app_developer']
    },
     {
        path:"/settings/retarget_customer/:type",
        component:<ReTargetCustomerCE/>,
        private:true,
        roles:['app_developer']
    },

    {
        path:"/settings/subscription_point",
        component:<SubscriptionPoint/>,
        private:true,
        roles:['app_developer']
    },

    {
        path:"/settings/distribution_subscription_point",
        component:<DistributorSubscriptionPoint/>,
        private:true,
        roles:['app_developer']
    },

    {
        path:"/settings/work_from_employee_option",
        component:<WorkFromHomeEmployeeOption/>,
        private:true,
        roles:['app_developer']
    },

    {
        path:"/settings/client_assign_time",
        component:<ClientAssignTime/>,
        private:true,
        roles:['app_developer']
    },
    {
        path:"/settings/voice_call_list",
        component:<VoiceCallList/>,
        private:true,
        roles:['app_developer']
    },
    {
        path:"/settings/voice_call_list/detail",
        component:<VoiceCallListDetail/>,
        private:true,
        roles:['app_developer']
    },
    {
        path:"/settings/message_target_list",
        component:<TemplateTargetList/>,
        private:true,
        roles:['app_developer']
    },
    {
        path:"/settings/message_target_list/detail",
        component:<TemplateTargetListDetail/>,
        private:true,
        roles:['app_developer']
    },
   
    {
        path:"/settings/department",
        component:<DepartmentList/>,
        private:true,
        roles:['controller','admin']
    },
   
    {
        path:"/dashboard",
        component:<DashboardMenu/>,
        private:true,
        roles:[]
    },
    {
        path:"/dashboard/my_dashboard",
        component:<Dashboard/>,
        private:true,
        roles:[]
    },   
    {
        path:"/settings/department/create",
        component:<DepartmentCE/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/settings/department/edit",
        component:<DepartmentCE/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/settings/designation",
        component:<DesignationList/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/settings/designation/create",
        component:<DesignationCE/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/settings/designation/edit",
        component:<DesignationCE/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/settings/roles",
        component:<RoleList/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/settings/roles/create",
        component:<RoleCE/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/settings/roles/edit",
        component:<RoleCE/>,
        private:true,
        roles:['controller','admin']
    },

    {
        path:"/settings/client_excel_upload",
        component:<ClientExcelUpload />,
        private:true,
        roles:['controller','admin','app_developer']
    },
     {
        path:"/settings/teacher_client_excel_upload",
        component:<ClientExcelUploadToTeacher />,
        private:true,
        roles:['controller','admin','app_developer']
    },
    
    {
        path:"/settings",
        component:<Settings/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/settings/onboard_list",
        component:<OnboardList/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/settings/onboard_list/create",
        component:<Onboard/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/settings/onboard_list/edit",
        component:<Onboard/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/settings/meta_message_list",
        component:<MetaList/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/settings/wati_message_list",
        component:<WatiList/>,
        private:true,
        roles:['controller','admin']
    },
     {
        path:"/settings/welcome_message_list",
        component:<TemplateListWelcome/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/settings/wati_message_list/:type",
        component:<WatiCE/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/settings/wati_template_list",
        component:<WatiTemplateList/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/settings/wati_template_list/:type",
        component:<WatiTemplateDetail/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/profile",
        component:<Mainprofile/>,
        private:true,
        roles:[]
    },
    // {
    //     path:"/privacy",
    //     component:<PrivacyPolicy/>,
    //     private:false,
    //     roles:[]

    // },
    {
        path:"/profile",
        component:<Profile/>,
        private:true,
        roles:[]
    },
    {
        path:"/profile/basic",
        component:<Mainprofile/>,
        private:true,
        roles:[]
    },
    {
        path:"/profile/update_password",
        component:<UpdatePassword/>,
        private:true,
        roles:[]
    },
    {
        path:"/profile/account",
        component:<Account/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path: "/clients",
        component: <ClientMenu />,
        private: true,
        roles: []
    },
    {
        path: "/clients/list/call_to_customer",
        component: <ClientCall />,
        private: true,
        roles: []
    },
    {
        path: "/clients/list/call_to_customer/:type",
        component: <ClientCallCE />,
        private: true,
        roles: []
    },
    
     {
        path: "/call_followup/:type",
        component: <CallFollowUpList />,
        private: true,
        roles: []
    },
    {
        path: "/call_followup/:type/:type",
        component: <ClientCallFollowUpCE />,
        private: true,
        roles: []
    },
    {
        path: "/clients/:type",
        component: <ClientList />,
        private: true,
        roles: []
    },
    {
        path: "/clients/:type/:type",
        component: <ClientListCE />,
        private: true,
        roles: []
    },
    {
        path: "/dashboard/our_clients",
        component: <AdminClients />,
        private: true,
        roles: []
    },
    {
        path: "/dashboard/voice_call_answered_assigned",
        component: <VoiceCallListAssignedAnswered />,
        private: true,
        roles: []
    },
     {
        path: "/dashboard/template_message_delivered_assigned",
        component: <MassMessageListDeliveredAnswered />,
        private: true,
        roles: []
    },
    {
        path: "/dashboard/our_clients_analytics",
        component: <AdminClientsAnalytics />,
        private: true,
        roles: []
    },
    {
        path: "/dashboard/retarget_customer",
        component: <ReTargetClients />,
        private: true,
        roles: []
    },
    {
        path: "/dashboard/new_clients",
        component: <AdminClientsVisibalityDisabled />,
        private: true,
        roles: []
    },
    {
        path: "/dashboard/chat_window",
        component: <AdminChatWindow />,
        private: true,
        roles: []
    },
    {
        path: "/dashboard/our_clients/:type",
        component: <ClientListCE />,
        private: true,
        roles: []
    },
    {
        path: "/dashboard/new_clients/:type",
        component: <ClientListCE />,
        private: true,
        roles: []
    },
    {
        path: "/dashboard/leader_board",
        component: <LeaderBoard />,
        private: true,
        roles: []
    },
     {
        path: "/dashboard/leader_board_main",
        component: <LeaderBoardWorkStatus />,
        private: true,
        roles: []
    },
    {
        path: "/dashboard/admin_call_followup",
        component: <AdminCallFollowUpList />,
        private: true,
        roles: []
    },
    {
        path: "/dashboard/subscribed_client_transfer",
        component: <AdminSubscribedClientsTransfer />,
        private: true,
        roles: []
    },
    {
        path: "/dashboard/leader_board/detail",
        component: <LeaderBoardTransaction />,
        private: true,
        roles: []
    },
    {
        path: "/dashboard/notification",
        component: <Notification />,
        private: true,
        roles: []
    },
    {
        path: "/withdraw",
        component: <WithDrawMenu />,
        private: true,
        roles: ['wfh','admin']
    },
    {
        path: "/withdraw/list",
        component: <WithDrawRequestList />,
        private: true,
        roles: ['wfh','admin']
    },
    {
        path: "/withdraw/list/:type",
        component: <WithDrawCE />,
        private: true,
        roles: ['wfh','admin']
    },
    {
        path: "/dashboard/withdraw_request",
        component: <AdminWithDrawRequestList />,
        private: true,
        roles: ['admin']
    },
    {
        path: "/dashboard/withdraw_request/:type",
        component: <WithDrawCE />,
        private: true,
        roles: ['admin']
    },
    {
        path: "/dashboard/track_employee",
        component: <TrackEmployeeClients />,
        private: true,
        roles: ['admin']
    },
    {
        path: "/dashboard/track_employee/detail",
        component: <TrackEmployeeClientsDetail />,
        private: true,
        roles: ['admin']
    },
    {
        path: "/settings/get_chat_success",
        component: <GetCustomerChatList />,
        private: true,
        roles: []
    },
    {
        path: "/settings/template",
        component: <TemplateList />,
        private: true,
        roles: []
    },
    {
        path: "/settings/website_option",
        component: <WebsiteMessageList />,
        private: true,
        roles: []
    },
    {
        path: "/settings/template/:type",
        component: <TemplateCE />,
        private: true,
        roles: []
    },
    {
        path: "/dashboard/live_class",
        component: <LiveClassList />,
        private: true,
        roles: []
    },
    {
        path: "/dashboard/live_class/attendees",
        component: <LiveClassListAttendees />,
        private: true,
        roles: []
    },
    {
        path: "/dashboard/live_class/:type",
        component: <LiveClassListCE />,
        private: true,
        roles: []
    },
    {
        path: "/settings/teacher_list",
        component: <TeacherList />,
        private: true,
        roles: []
    },
    {
        path: "/settings/teacher_list/:type",
        component: <TeacherCE />,
        private: true,
        roles: []
    },
    {
        path: "/settings/distributor_list",
        component: <DigitalCardDistributorList />,
        private: true,
        roles: []
    },
    {
        path: "/settings/distributor_list/:type",
        component: <DigitalCardDistributorCE />,
        private: true,
        roles: []
    },
    {
        path: "/settings/booking_count_assign",
        component: <ClassBookingCount />,
        private: true,
        roles: []
    },
    {
        path: "/settings/personal_training_subscription",
        component: <PersonalTrainingSubscriptionList />,
        private: true,
        roles: []
    },
    {
        path: "/settings/personal_training_subscription/:type",
        component: <PersonalTrainingSubscriptionCE />,
        private: true,
        roles: []
    },
    {
        path: "/settings/class_home_page_data",
        component: <ClassHomePageDataList />,
        private: true,
        roles: []
    },
    {
        path: "/settings/class_home_page_data/:type",
        component: <ClassHomePageDataCE />,
        private: true,
        roles: []
    },
    {
        path: "/settings/booking_slot",
        component: <BookingSlot />,
        private: true,
        roles: []
    },
    {
        path: "/settings/booking_slot/:type",
        component: <BookingSlotCE />,
        private: true,
        roles: []
    },
     {
        path: "/settings/batches_slot",
        component: <BatchesSlot />,
        private: true,
        roles: []
    },
    {
        path: "/settings/batches_slot/:type",
        component: <BatchesSlotCE />,
        private: true,
        roles: []
    },
    {
        path: "/class_booking",
        component: <TeacherClassBookingMenu />,
        private: true,
        roles: []
    },
    {
        path: "/class_booking/:type",
        component: <TeacherClassBookingList />,
        private: true,
        roles: []
    },
    {
        path: "/class_booking/:type/:type",
        component: <TeacherClassBookingCE />,
        private: true,
        roles: []
    },
    {
        path: "/batches_booking",
        component: <BatchBookingMenu />,
        private: true,
        roles: []
    },
    {
        path: "/batches_booking/custom_download",
        component: <BatchCustomDownload />,
        private: true,
        roles: []
    },
    {
        path: "/batches_booking/:type",
        component: <BatchBookingList />,
        private: true,
        roles: []
    },
    {
        path: "/batches_booking/list/time_table",
        component: <BatchSubscriptionTimeTable />,
        private: true,
        roles: []
    },
    {
        path: "/my_time_table",
        component: <MyTimeTableList />,
        private: true,
        roles: []
    },
    {
        path: "/today_time_table",
        component: <TodayTimeTableList />,
        private: true,
        roles: []
    },
     {
        path: "/batches_booking/list/time_table/:type",
        component: <BatchSubscriptionTimeTableCE />,
        private: true,
        roles: []
    },
    {
        path: "/batches_booking/list/time_table/student_summary",
        component: <BatchSubscriptionTimeTableStudentSummary />,
        private: true,
        roles: []
    },
    {
        path: "/batches_booking/:type/:type",
        component: <BatchBookingCE />,
        private: true,
        roles: []
    },
    {
        path: "/settings/demo_booking_list",
        component: <DemoBookingList />,
        private: true,
        roles: []
    },
    {
        path: "/settings/demo_booking_list/:type",
        component: <DemoBookingCE />,
        private: true,
        roles: []
    },
    {
        path: "/settings/batch_subscription_list",
        component: <BatchSubscriptionList />,
        private: true,
        roles: []
    },
    {
        path: "/settings/batch_subscription_list/time_table",
        component: <BatchSubscriptionTimeTable />,
        private: true,
        roles: []
    },
    {
        path: "/settings/batch_subscription_list/time_table/student_summary",
        component: <BatchSubscriptionTimeTableStudentSummary />,
        private: true,
        roles: []
    },
    {
        path: "/settings/batch_subscription_list/time_table/:type",
        component: <BatchSubscriptionTimeTableCE />,
        private: true,
        roles: []
    },
    {
        path: "/settings/batch_subscription_list/:type",
        component: <BatchSubscriptionCE />,
        private: true,
        roles: []
    },
    {
        path: "/settings/all_booking_req",
        component: <GetSubscriptionRequestList />,
        private: true,
        roles: []
    },
    {
        path: "/settings/student_subject",
        component: <StudentSubjectList />,
        private: true,
        roles: []
    },
    {
        path: "/settings/current_link_model",
        component: <CurrentLinkModel />,
        private: true,
        roles: []
    },
    {
        path: "/settings/student_subject/:type",
        component: <StudentSubjectCE />,
        private: true,
        roles: []
    },
     {
        path: "/settings/student_stream",
        component: <StudentStreamList />,
        private: true,
        roles: []
    },
    {
        path: "/settings/student_stream/:type",
        component: <StudentStreamCE />,
        private: true,
        roles: []
    },
     {
        path: "/settings/student_stream",
        component: <StudentStreamList />,
        private: true,
        roles: []
    },
    {
        path: "/settings/student_stream/:type",
        component: <StudentStreamCE />,
        private: true,
        roles: []
    },
    {
        path: "/settings/student_board",
        component: <StudentBoardList />,
        private: true,
        roles: []
    },
    {
        path: "/settings/student_board/:type",
        component: <StudentBoardCE />,
        private: true,
        roles: []
    },
    {
        path: "/settings/class_room",
        component: <ClassRoomList />,
        private: true,
        roles: []
    },
    {
        path: "/settings/class_room/:type",
        component: <ClassRoomCE />,
        private: true,
        roles: []
    },
    {
        path: "/settings/subject",
        component: <SubjectList />,
        private: true,
        roles: []
    },
    {
        path: "/settings/subject/:type",
        component: <SubjectCE />,
        private: true,
        roles: []
    },
    {
        path: "/settings/chapter",
        component: <ChapterList />,
        private: true,
        roles: []
    },
    {
        path: "/settings/chapter/:type",
        component: <ChapterCE />,
        private: true,
        roles: []
    },
    {
        path: "/counselling_client_followup",
        component: <CounsellingFollowupMenu />,
        private: true,
        roles: []
    },
    {
        path: "/counselling_client_followup/:type",
        component: <CounsellingFollowupList />,
        private: true,
        roles: []
    },
    {
        path: "/offline_student",
        component: <OfflineCustomerList />,
        private: true,
        roles: []
    },
    {
        path: "/offline_student/:type",
        component: <OfflineCustomerList />,
        private: true,
        roles: []
    },
    {
        path: "/offline_student/:type/:type",
        component: <OfflineCustomerCE />,
        private: true,
        roles: []
    },
     {
        path: "/invoice",
        component: <InvoiceMenu />,
        private: true,
        roles: []
    },
    {
        path: "/invoice/:type",
        component: <InvoiceList />,
        private: true,
        roles: []
    },
    {
        path: "/invoice/:type/:type",
        component: <InvoiceCE />,
        private: true,
        roles: []
    },
    {
        path: "/parent_feedback",
        component: <PublicFeedbackMobileEntry />,
        private: false,
        roles: []
    },
    {
        path: "/parent_feedback/teachers",
        component: <PublicFeedbackTeacherList />,
        private: false,
        roles: []
    },
    {
        path: "/parent_feedback/form/:teacherId",
        component: <PublicFeedbackForm />,
        private: false,
        roles: []
    },
    {
        path: "/teacher_feedback_leaderboard",
        component: <TeacherFeedbackLeaderboard />,
        private: true,
        roles: ['Teacher', 'admin']
    },
    {
        path: "/settings/parent_feedback",
        component: <AdminTeacherFeedbackList />,
        private: true,
        roles: ['admin']
    },
    {
        path: "/settings/city_list",
        component: <CityList />,
        private: true,
        roles: ['admin']
    }

]

